import get from "lodash/get";
import PT from "prop-types";
import React, { Fragment, useRef } from "react";
import Newsletter from "../../../atoms/Newsletter";
import { MultipleAuthorDetails } from "../../atoms";
import CopyRight from "../gn-copy-right";
import HeadlineFirstLayout from "../head-line-first";
import ImageFirstLayout from "../image-first-layout";
import StoryCard from "./StoryCard";

import { useSelector } from "react-redux";
import ProgressBar from "../../atoms/ProgressBar";
import "./gn-reach-template.m.css";

export default function GnReach({ story, config, storyIndex }) {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const articleApi = get(qtState, ["config", "articleApi"], {});
  const layoutType = get(story, ["metadata", "story-attributes", "layout", "0"], "");
  const hasBgColor = get(story, ["metadata", "story-attributes", "gnreachbgcolor", "0"], "");
  const scrollRef = useRef(null);
  const bgColorStyle =
    hasBgColor.toLowerCase() === "show"
      ? { backgroundColor: "#F7F7F4", maxWidth: "100%" }
      : { backgroundColor: "white", maxWidth: "100%" };
  const wrapper = layoutType === "Headline_First" ? "headline-first-wrapper" : "image-first-wrapper";

  return (
    <Fragment>
      {!Object.keys(articleApi).length && <ProgressBar story={story} scrollRef={scrollRef} storyIndex={storyIndex} />}
      <div ref={scrollRef}>
        <div styleName={wrapper} style={bgColorStyle}>
          <div styleName="label">PARTNER CONTENT</div>
          {layoutType === "Headline_First" ? <HeadlineFirstLayout story={story} /> : <ImageFirstLayout story={story} />}
        </div>
        <div styleName="story-cards-div">
          {story?.cards?.map((card) => {
            return <StoryCard card={card} story={story} />;
          })}
        </div>
        {story?.authors?.length > 3 && (
          <div styleName="story-bottom-div multiple-authors">
            <MultipleAuthorDetails story={story} />
          </div>
        )}
        <div styleName="story-bottom-div">{!articleApi && <Newsletter />}</div>

        <div styleName="tags">
          {story?.tags?.map((tag) => (
            <span>{tag.name}</span>
          ))}
        </div>

        <CopyRight />
      </div>
    </Fragment>
  );
}

GnReach.propTypes = {
  story: PT.object,
  config: PT.object,
};
